import { render, staticRenderFns } from "./VueSearch.vue?vue&type=template&id=70b119c4&scoped=true&"
import script from "./VueSearch.vue?vue&type=script&lang=js&"
export * from "./VueSearch.vue?vue&type=script&lang=js&"
import style0 from "./VueSearch.vue?vue&type=style&index=0&id=70b119c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b119c4",
  null
  
)

export default component.exports